import {toast} from 'react-toastify';
import React from 'react';

export const AUTHENTICATION_DATA_LOCALSTORAGE_KEY = 'authenticationData';
export const REFERRAL_ID_SESSIONSTORAGE_KEY = 'referralId';
export const GLOBAL_REDIRECT_SESSIONSTORAGE_KEY = 'globalRedirectTo';

export const DEFAULT_TOAST_AUTOCLOSE_TIME = 10000;

export const KICBAC_TO_USD_RATIO = 0.01;

export const SLACK_INSTALL_ENCRYPT_KEY = '4956784425kehsdv9348622281hdgryc';

export const TOAST_FULLWIDTH_OPTIONS = {
    autoClose: false,
    closeButton: <div className="dark_bt-menu">
        <strong className="bold-text">Got It!</strong>
    </div>,
    position: toast.POSITION.TOP_LEFT,
    className: 'full_width_toast'
};

export const MAIN_PAGE_URL = '/dashboard';

export const HEADER_CSV_CAMPAIGN_CODE = [
    { label: 'Campaign Name', key: 'campaignName' },
    { label: 'Campaign Medium', key: 'campaignMedium' },
    { label: 'Amount', key: 'amount' },
    { label: 'Redirect To', key: 'redirectTo' },
    { label: 'Max Redemptions', key: 'maxRedemptions' },
    { label: 'Number Redemptions', key: 'numberRedemptions' },
    { label: 'Code', key: 'code' },
    { label: 'Updated At', key: 'updatedAt' },
    { label: 'Status', key: 'status' },
    { label: 'Short Link', key: 'shortUrl' },
    { label: 'Long Link', key: 'longLink' },
];

export const HEADER_CSV_WALLET_ACTIVITY = [
    { label: 'User entity', key: 'user' },
    { label: 'Event description', key: 'description' },
    { label: 'Created at', key: 'createdAt' },
    { label: 'Debit amount', key: 'debitAmount' },
    { label: 'Credit amount', key: 'creditAmount' },
    { label: 'Event type', key: 'eventType' },
    { label: 'Activity id', key: 'activityId' },
    { label: 'User event message', key: 'eventMessage' },

];

export const DATE_FORMAT = 'MM DD, YYYY';
